<template>
  <div>
    <actions-menu :actions="actions" @edit-opportunity="toggleModal">
    </actions-menu>
    <job-opportunity-modal
      v-if="opportunityModal"
      :job-id="jobId"
      :technician="technician"
      :opportunity-status="opportunityStatus"
      :lead-type="leadType"
      :lead-source="leadSource"
      :booking-call-id="bookingCallId"
      @hide-modal="toggleModal"
    ></job-opportunity-modal>
  </div>
</template>

<script>
import ActionsMenu from "@/components/ActionsMenu.vue";
import JobOpportunityModal from "@/Job/Opportunity/JobOpportunityModal.vue";

export default {
  components: {
    ActionsMenu,
    JobOpportunityModal
  },
  props: {
    jobId: {
      type: Number,
      default: null
    },
    opportunityStatus: {
      type: String,
      default: ""
    },
    technician: {
      type: Object,
      default: null
    },
    leadType: {
      type: String,
      default: null
    },
    leadSource: {
      type: String,
      default: null
    },
    bookingCallId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      opportunityModal: false,
      actions: [
        {
          label: "Edit Opportunity",
          icon: "fa-regular fa-edit",
          eventName: "edit-opportunity"
        }
      ]
    };
  },
  methods: {
    toggleModal() {
      this.opportunityModal = !this.opportunityModal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
